























































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseContainer from '@/components/BaseContainer.vue';
import { formRules } from '@/common/util/validator';
import { Inquiry, CspOrder, PriceList } from '@/http';
import publicFunc from '../../common/util/publicFunc';
import { PaginationPanel } from '@/components';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: { StatusPanel, BaseContainer, PaginationPanel, DataPanel },
})
export default class freightDetail extends Vue {
    public publicFunc: any = publicFunc;
    public loading = false;
    public rePagin = false;
    public formRules = formRules;
    public currentBtn2: any = [];
    public id: any = '';
    public carLengthList: any = [];
    public currentBtn: any = [];
    public priceListType: any;
    public async mounted() {
        this.id = this.$route.query.id;
        let res = await Inquiry.GetDicDetailList({
            typeName: 'carLength',
            count: -1,
        });
        this.carLengthList = res.map((v) => {
            return v.name;
        });
        res.forEach((item) => {
            this.colData.push({
                carLength: item.name,
            });
        });
        this.formData = await PriceList.GetPriceListItem(this.id);
        this.formData.time = [this.formData.beginDate, this.formData.endDate];
        this.currentBtn = JSON.parse(JSON.stringify(this.formData.titleList));
        this.priceListType = this.formData.priceListType;
        // console.log('this.formData' + JSON.stringify(this.formData));
        if (this.formData.priceListType == 1) {
            this.currentBtn2 = [];
            let temp = [];
            this.formData.titleList.forEach((i) => {
                temp.push(i + '（元/车）');
            });
            this.currentBtn2 = temp;
        } else if (this.formData.priceListType == 3) {
            this.currentBtn2 = [];
            this.currentBtn2 = JSON.parse(JSON.stringify(this.formData.titleList));
        } else {
            this.currentBtn2 = [];
            let temp = [];
            this.formData.titleList.forEach((i) => {
                temp.push(i + '（元/吨）');
            });
            this.currentBtn2 = temp;
        }
        this.loadData();
    }
    public colData: any = [];
    public $refs: {
        formData: HTMLFormElement;
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
    };
    public formData: any = {};
    public searchValue: any = {
        delivery: '',
        arrival: '',
    };
    public resetSearchValue() {
        this.searchValue = { delivery: '', arrival: '' };
        this.loadData();
    }
    updateBtn(item, index) {
        console.log('this.currentBtn' + JSON.stringify(this.currentBtn));
        if (this.currentBtn.includes(item)) {
            this.currentBtn.splice(this.currentBtn.indexOf(item), 1);
        } else {
            this.currentBtn.push(item);
        }
    }
    save() {
        // console.log('this.formData' + JSON.stringify(this.formData));
        // console.log('this.tableData' + JSON.stringify(this.tableData));

        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                let detailList = [];
                this.tableData.forEach((i) => {
                    detailList.push({
                        id: i.id,
                        priceContent: i.priceContent,
                    });
                });
                let obj = {
                    id: this.id,
                    beginDate: this.formData.time[0],
                    endDate: this.formData.time[1],
                    detailList: detailList,
                };
                await PriceList.UpdatePriceList(obj);
                this.$message.success('保存成功');
                this.loadData();
            }
        });
    }
    del(row) {
        this.$confirm('确认删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.DeletePriceListDetail(row.id).then(() => {
                    this.$message.success('删除成功');
                    this.loadData();
                });
            })
            .catch(() => {});
        // this.tableData.splice(index - 1, 1);
        // this.tableData.forEach((item, index) => {
        //     item.index = index + 1;
        // });
    }
    effective() {
        this.$confirm('确认立即生效运价表?', '运价表生效', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.PriceListTakeEffect(this.id).then(() => {
                    this.$message.success('运价表生效成功!');
                    this.loadData();
                });
            })
            .catch(() => {});
    }
    unEffective() {
        this.$confirm('确认立即失效运价表?', '运价表失效', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                PriceList.PriceListLoseEfficacy(this.id).then(() => {
                    this.$message.success('运价表失效成功!');
                    this.$router.push('/freightConfig');
                });
            })
            .catch(() => {});
    }

    public async exportExcel() {
        let data = await PriceList.ExportPriceListExcel(this.id);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('导出失败!');
        // }
    }

    public async download() {
        let data = await PriceList.GetPriceListExcelTemplate(this.id);
        // if (data && data.attachmentUrl) {
        //     window.open(data.attachmentUrl);
        // } else {
        //     this.$message.warning('模板下载失败!');
        // }
    }

    /* 错误类型 */
    public errorType: number = null;
    public dialogVisible = false;
    public errList: any = [];
    public batchImportList: any = [];
    async updateExcel(e: any) {
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        console.log('param' + param);
        let res = await PriceList.ImportPriceListDetail(this.id, param);
        this.$message.success('导入成功!');
        this.loadData();
        return;
        if (res.validity) {
            await CspOrder.AddExcelData(res);
            this.loadData();
            this.$message.success('导入成功!');
        } else {
            this.errorType = res.validityStatus;
            if (this.errorType == 0) {
                this.$message.success('操作成功!');
                this.loadData();
            }
            if (this.errorType == 1) {
                if (res.orderList.length == 0) {
                    this.$message.error('Excel表格为空，无法上传！');
                } else {
                    this.$message.error('一次最多上传100条订单，请删减后重新上传！');
                }
            }
            if (this.errorType == 2) {
                this.errList = [];
                this.errList = res.errRowCellList;
                this.batchImportList = [];
                console.log('res.orderList' + JSON.stringify(res.orderList));
                res.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            } else if (this.errorType == 3) {
                this.errList = res.repeatRow;
                this.batchImportList = [];
                res.orderList.forEach((item) => {
                    this.batchImportList.push(item);
                });
                this.dialogVisible = true;
                console.log('this.errList' + JSON.stringify(this.errList));
            }
        }
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };

    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadData();
    }
    public tableData: any = [];
    public total = 0;
    public async loadData() {
        this.loading = true;
        try {
            let res = await PriceList.GetPriceListDetailList({
                ...this.searchValue,
                priceListId: this.id,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            res.data.forEach((item) => {
                item.lineStr =
                    item.deliveryProvince + item.deliveryCity + item.deliveryArea + '-' + item.arrivalProvince + item.arrivalCity + item.arrivalArea;
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.tableData.map((item, index) => {
                item.priceContent.forEach((i) => {
                    if (this.priceListType == 1) {
                        i.titleName = i.titleName + '（元/车）';
                    }
                    if (i.priceValue == '') {
                        i.priceValue = undefined;
                    }
                });
                item.index = skip++ + 1;
            });
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.total = res.total;

            this.loading = false;
        } catch {
            this.loading = false;
        }
    }
}
